export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/swooping-arrow.23b41103.svg","height":84,"width":250};